<template>
  <v-layout>
    <left-drawer/>
    <right-drawer/>
    <v-app-bar dense app>
      <v-app-bar-nav-icon v-if="!usaLeft2" @click="openLeftDrawer"></v-app-bar-nav-icon>
      <v-app-bar-title>
        <span>Ubisell backoffice</span> 
        <span class="ml-5" v-if="nomeAzienda" @click="cambiaAzienda">Azienda: {{ nomeAzienda }}</span>
        <span class="ml-5 text-subtitle-1">{{ magazzinoSelezionato }}</span>
        <!-- <span class="ml-5"><led-servizi /></span> -->
        <span class="ml-5" v-if="nomeAzienda && verificaStatusInterval"><led v-for="(stato, idx) in statoServizi" :key="idx" :status="stato" :baseExpected="baseExpected"/></span>
        <span v-if="verificaStatusInterval && erroreAggiornamentoServizi" class="ml-5 red--text">Attenzione! Verificare lo stato dei servizi</span>
      </v-app-bar-title>
      <v-spacer></v-spacer>
      <watson-assistant v-if="abilitaWatson"/>
      <!-- <v-btn icon><v-icon>mdi-magnify</v-icon></v-btn> -->
      <v-btn v-if="abilitaHelp" icon @click="showHelp=true"><v-icon>mdi-help-circle-outline</v-icon></v-btn>
    </v-app-bar>
    <v-dialog v-model="dialogCambiaAzienda" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"><p>Seleziona l'azienda da attivare</p></v-card-title>
        <v-card-text>
          <v-select v-model="aziendaDaSelezionare" :items="aziendeDisponibili" dense flat outlined label="Aziende disponibili" item-text="descrizione" item-value="codice" clearable hide-details return-object></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="confermaCambio">Conferma</v-btn>
          <v-btn color="blue darken-1" text @click="dialogCambiaAzienda=false">Annulla</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Sizes your content based upon application components -->
    <v-main>
      <v-container fluid>
        <router-view v-if="!showHelp"></router-view>
        <iframe v-if="showHelp" :src="helpSource" width="100%" height="90vh" frameborder="0" style="overflow:hidden;height:90vh;width:100%"></iframe>
      </v-container>
    </v-main>
    <v-footer app>
      <!-- -->
    </v-footer>
  </v-layout>
</template>

<script>
import LeftDrawer from '@/views/drawer/leftDrawer2_bis'
import RightDrawer from '@/views/drawer/rightDrawer'
import WatsonAssistant from '@/views/drawer/watson/watsonAssistant_1'
import Led from './led.vue'

import appuntamenti from '@/services/appuntamentiService'
import clienti from '@/services/clientiService'
import configurazioni from '@/services/configurazioniService'
import documenti from '@/services/documentiService'
import fidelity from '@/services/fidelityService'
import etichette from '@/services/etichetteService'
import magazzino from '@/services/magazzinoService'
import movimenti from '@/services/movimentiService'
import prodotti from '@/services/prodottiService'
import reporting from '@/services/reportingService'
import scontrini from '@/services/scontriniService'
import tabelle from '@/services/tabelleService'

// Nel caso di accesso alla pagina mobile posso cambiare il drawer o nasconderlo completamente
export default {
  name: 'App',
  components: {
    LeftDrawer,
    RightDrawer,
    WatsonAssistant,
    Led
  },
  data: () => ({
    magazzinoSelezionato: '',
    usaLeft2: true,
    showHelp: false,
    abilitaHelp: false, // TODO: Inserire su impostazioni,
    abilitaWatson: false, // TODO: Da impostazioni,
    dialogCambiaAzienda: false,
    aziendeDisponibili: [],
    aziendaSelezionata: null,
    aziendaDaSelezionare: null,
    statoServizi: [],
    secondiVerifica: 0,
    verificaStatusInterval: null,
    baseDb: '',
    erroreAggiornamentoServizi: false,
    pollingInCorso: false
  }),
  watch:{
    $route (to, from) {
      this.showHelp = false
    },
    magazzino(value) {
      this.magazzinoSelezionato = value.descrizione
    },
    secondiVerifica(val) {
/*       if (this.secondiVerifica <= 20 || this.erroreAggiornamentoServizi) {
        await this.getProcessStatus()
        this.secondiVerifica += 2
      } */
      if (this.secondiVerifica > 10 && !this.erroreAggiornamentoServizi) {
        clearInterval(this.verificaStatusInterval)
        this.verificaStatusInterval = null
      }
    }
  },
  async mounted() {
    const multipli = window.appConfig.multipli
    const magazzino = await this.$store.dispatch('magazzini/getMagazzino')
    this.magazzinoSelezionato = magazzino.descrizione
    this.aziendeDisponibili = multipli || []
    if (this.aziendeDisponibili.length > 0) {
      this.avviaVerificaStatus()
      await this.getProcessStatus()

      this.aziendaSelezionata = this.aziendeDisponibili.find(x => x.codice === this.baseDb) || this.aziendeDisponibili[0]
    }
  },
  computed: {
    magazzino() {
      return this.$store.getters['magazzini/magazzino']
    },
    helpSource() {
      const base = 'http://localhost:8083'
      let argument = '' // ottenuto dal path o dai meta del path ...
      return  base + (argument ? '/' + argument : '')
    },
    nomeAzienda() {
      return this.aziendaSelezionata ? this.aziendaSelezionata.descrizione : ''
    },
    baseExpected() {
      return this.aziendaSelezionata ? this.aziendaSelezionata.codice : ''
    }
  },
  methods: {
    async avviaVerificaStatus(cambio) {
      this.secondiVerifica = 0
      this.verificaStatusInterval = setInterval(async () => {
        if (this.pollingInCorso) {
          return
        }
        if (this.secondiVerifica <= 20 || this.erroreAggiornamentoServizi) {
          this.pollingInCorso = true
          await this.getProcessStatus()
          this.secondiVerifica += 2
          if (!this.erroreAggiornamentoServizi && cambio) {
            location.href = location.href
          }
          this.pollingInCorso = false
        }
      }, 2000)
    },
    openLeftDrawer() {
      this.$store.commit('SET_LEFT_DRAWER', true)
    },
    cambiaAzienda() {
      this.aziendaDaSelezionare = this.aziendaSelezionata
      this.dialogCambiaAzienda = true
    },
    async confermaCambio() {
      this.aziendaSelezionata = this.aziendaDaSelezionare
      const azienda = this.aziendaSelezionata
      // await this.cicleSyncProcess(azienda)
      // TODO: Aspettare che tutti i progetti abbiano risposto (e verificare che il valore di ritorno sia coerente con la scelta, altrimenti errore ...)
      // Va inserito anche il polling verso i processi per evidenziare lo stato ? Eventuale pannellino, insieme a scadenze, fatture, etc.

      // TODO: Verificare, provo a non mettere await per evitare di aspettare un modulo in errore
      appuntamenti.cicleSync(azienda)
      clienti.cicleSync(azienda)
      configurazioni.cicleSync(azienda)
      documenti.cicleSync(azienda)
      fidelity.cicleSync(azienda)
      magazzino.cicleSync(azienda)
      movimenti.cicleSync(azienda)
      prodotti.cicleSync(azienda)
      scontrini.cicleSync(azienda)
      this.avviaVerificaStatus(true)
      this.dialogCambiaAzienda = false
    },
    async getProcessStatus() {
      const status = []
      const statusPromise = []
      try {
        statusPromise.push(prodotti.getRunMode())
        const statusConfigurazioni = await configurazioni.getRunMode()
        this.baseDb = statusConfigurazioni.baseDb
        statusPromise.push(statusConfigurazioni)
        statusPromise.push(movimenti.getRunMode())
        statusPromise.push(fidelity.getRunMode())
        statusPromise.push(scontrini.getRunMode())
        statusPromise.push(clienti.getRunMode())
        statusPromise.push(appuntamenti.getRunMode())
        statusPromise.push(etichette.getRunMode())
        statusPromise.push(magazzino.getRunMode())
        statusPromise.push(tabelle.getRunMode())
        statusPromise.push(documenti.getRunMode())
        statusPromise.push(reporting.getRunMode())

        let erroreServizi = false
/*         for (let s of status) {
          if (s.health !== true || (s.baseDb !== '' && s.baseDb !== this.baseExpected)) {
            erroreServizi = true
          }
        } */
        const results = await Promise.allSettled(statusPromise);
        for (const [index, result] of results.entries()) {
          if (result.status === 'fulfilled') {
              // console.log(`Result ${index + 1}:`, s);
              const s = result.value
              status.push(s)
              if (s.health !== true || (s.baseDb !== '' && s.baseDb !== this.baseExpected)) {
                erroreServizi = true
              }              
          }/*  else {
              console.warn(`Error in result ${index + 1}:`, s.reason.message);
          } */
        }


        this.erroreAggiornamentoServizi = erroreServizi
      } catch (error) {
        console.log('errore getProcessStatus', error)
      }
      this.statoServizi = status
    }    
  }
};
</script>

<style lang="scss" scoped>
  .scale-slide-enter-active,
  .scale-slide-leave-active {
    position: absolute;
    transition: all 0.85s ease;
  }


  .scale-slide-enter-from {
    left: -100%;
  }


  .scale-slide-enter-to {
    left: 0%;
  }


  .scale-slide-leave-from {
    transform: scale(1);
  }


  .scale-slide-leave-to {
    transform: scale(0.8);
  }
</style>